import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Card, Badge, Row, Col } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle } from '@fortawesome/pro-solid-svg-icons';

import { addLibraryPage } from '../store/actions';
import badgeClass from '../shared/document_badge';
import { getPageKey } from './page_key_helper';

function AvailablePages({ addLibraryPage, pages, locked }) {
  const cardOverflowCss = {
    maxHeight: '475px',
    overflowY: 'auto'
  };

  return (
    <React.Fragment>
      {!locked && (
        <div>
          <div className="my-3 d-flex align-items-center">
            <div className="flex-grow-1">
              <strong className="fw-semibold">Available Pages</strong>
            </div>
          </div>
          {pages.length === 0 && (
            <div className="text-muted py-4 text-center">No results</div>
          )}
          {pages.length !== 0 && (
            <Card className="overflow-auto" style={cardOverflowCss}>
              <ul className="list-group list-group-flush">
                {pages.map(page => (
                  <li className="list-group-item" key={getPageKey(page)}>
                    <Row className="align-items-center w-100">
                      <Col xs={3}>
                        {page.name}
                      </Col>
                      <Col xs={6}>
                        {page.user_label && (
                          <Badge className={`${badgeClass('user_label')} m-1`}>{page.user_label}</Badge>
                        )}
                        {page.size && (
                          <Badge bg="muted" className={`${badgeClass('size', page.size)} m-1`}>{page.size}</Badge>
                        )}
                      </Col>
                      <Col className="text-end" xs={3}>
                        <FontAwesomeIcon
                          className="text-success clickable ms-4"
                          icon={faPlusCircle}
                          name="add-page"
                          onClick={() => addLibraryPage(page.id, page.template_type)}
                        />
                      </Col>
                    </Row>
                  </li>
                ))}
              </ul>
            </Card>
          )}
        </div>
      )}
    </React.Fragment>
  );
}

AvailablePages.propTypes = {
  addLibraryPage: PropTypes.func.isRequired,
  allAvailablePages: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired
  })),
  locked: PropTypes.bool,
  pages: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  })).isRequired
};

const mapStateToProps = ({ availablePages, formData }) => {
  const documentTemplateAvailablePageIds = formData.availablePageTemplateTreeIds || [];

  // Filter out pages that are already in the library
  // Compare both id AND template_type to handle ID collisions between different types
  const pages = availablePages.filter((page) => {
    return !documentTemplateAvailablePageIds.some(p => p.id === page.id && p.template_type === page.template_type
    );
  });

  return { pages };
};

export default connect(mapStateToProps, { addLibraryPage })(AvailablePages);
